<h3>{{ "My Payments" | translate }}</h3>
<div class="row mt-4" *ngFor="let payment of payments">
  <div class="col-12 col-sm-4">
    <div class="card m-2">
      <div class="card-body d-flex justify-content-between">
        <div *ngFor="let item of payment.paymentItems">
          <h5 class="card-title">{{ item.description }}</h5>
        </div>
        <h6 class="price">{{ payment.paymentAmount / 100 }} جنيه</h6>
      </div>
    </div>
  </div>
</div>
